import axios from "axios";
import { apiPentestsRetrieve } from "../../sdk";
import { Pentest } from "../../sdkStructs";

export async function fetchPentestStatus(token: string, pentestId: number) {
  try {
    const response = await apiPentestsRetrieve(token, pentestId);
    const newPentest: Pentest = response.data;
    return newPentest;
  } catch (error) {
    if (!axios.isAxiosError(error)) {
      return;
    }
    console.log("ERROR FETCHING PENTEST:", error.response);
  }
}
